module.exports = __webpack_public_path__ + "static/banner-87042b0108769489652e3610342fc04c.png";